import BaseLayout from 'layouts';
import { NextPageWithLayout } from '../../pages/page';

const FeedLayout: NextPageWithLayout<{
  hideBottomBar?: boolean;
  hideTopNavOnScroll?: boolean;
}> = ({ children, hideBottomBar = false, hideTopNavOnScroll = false }) => {
  return (
    <BaseLayout
      hideTopNavOnScroll={hideTopNavOnScroll}
      hideBottomBar={hideBottomBar}
    >
      {children}
    </BaseLayout>
  );
};

export default FeedLayout;
